import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			width: '70%',
			maxWidth: 1000
		}
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	tableRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		padding: 5
	},
	close: {
		position: 'absolute',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 12,
		cursor: 'pointer'
	},
	cell: {
		width: '20%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		'& h5': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 12,
			margin: 0,
			marginBottom: 3
		},
		'& span': {
			fontFamily: 'Nunito',
			fontSize: 16
		}
	},
	petRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 5,
		width: '100%',
		'& img': {
			height: 50,
			width: 50,
			borderRadius: 25,
			marginRight: 15
		},
		'& h4': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	}
}))

const ViewAddOnDialog = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const facility = useSelector((state) => state.specific.facilities.selected)
	const visit = useSelector((state) => state.specific.visits.selected)

	const { isShown, setIsShown, addOn, pet, visits } = props
	const [addOnTypeOptions, setAddOnTypeOptions] = useState(null)

	useEffect(() => {
		if (facility) {
			setAddOnTypeOptions(Object.keys(facility.add_on_services))
		}
	}, [facility])

	const goToVisit = () => {
		let visit
		if (addOn.visit_id) {
			visit = visits.find((v) => v._id === addOn.visit_id)
		}
		if (!addOn.visit_id && addOn.pet_id) {
			visit = visits.find((v) => v.pet_ids && v.pet_ids.includes(addOn.pet_id))
		}
		if (!visit) return alert('No visit found!')

		const baseUrl = `/clients/${visit.household_id}/appointments/${visit._id}`
		const win = window.open(baseUrl, '_blank')
		win.focus()
	}

	return !addOn ? null : (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={() => setIsShown(false)}>
			<DialogTitle>ENRICHMENT DETAIL</DialogTitle>
			<DialogContent>
				<span className={classes.close} onClick={() => setIsShown(false)}>
					X
				</span>
				<div className={classes.formWrapper}>
					<div className={classes.petRow}>
						{pet?.image_url && <img src={pet.image_url} />}
						{pet?.name && <h4>{pet.name}</h4>}
					</div>
					<div className={classes.tableRow}>
						<div className={classes.cell}>
							<h5>ENRICHMENT</h5>
							<span>{addOn.name}</span>
						</div>
						<div className={classes.cell}>
							<h5>OCCURRENCES</h5>
							<span>?</span>
						</div>
						<div className={classes.cell}>
							<h5>DATE</h5>
							<span>{moment(addOn.date).format('MMM D, YYYY')}</span>
						</div>
						<div className={classes.cell}>
							<h5>TIME BLOCK</h5>
							<span>{addOn.time}</span>
						</div>
						<div className={classes.cell}>
							<h5>STATUS</h5>
							<span>{addOn.status ? addOn.status : 'Waiting'}</span>
						</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="outlined" onClick={() => goToVisit()} color="secondary">
					VIEW ON APPOINTMENT
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default ViewAddOnDialog
